@if (resAsync | async) {
  <div fxFlexFill fxLayout="row" [dir]="rtlEnabled ? 'rtl' : 'auto'">
    <div fxFlex="100" style="height: 100%; display: flex; flex-direction: column">
      <div class="legendTitle">
        <div class="search-box" [ngClass]="rtlEnabled ? 'search-box-rtl' : ''">
          <input
            #searchInputRef
            type="text"
            (focus)="isFiltering = true"
            (focusout)="isFiltering = !!searchInput"
            [value]="searchInput ?? ''"
            (input)="applyFilter($event.target.value)"
            [ngClass]="isFiltering ? 'search-box-filtering' : ''"
          />
          <span (click)="searchInputRef.focus()"> </span>
          <button
            mat-icon-button
            [ngStyle]="{
              left: !rtlEnabled ? 'unset' : '1px',
              right: rtlEnabled ? 'unset' : '1px',
            }"
            (click)="resetFilter()"
          >
            <mat-icon [svgIcon]="res.svgName('Close-Image')"></mat-icon>
          </button>
        </div>
        <div [ngStyle]="{ overflow: 'hidden', display: isFiltering ? 'none' : 'block' }">
          <mat-icon
            [svgIcon]="res.svgName('Legend-OpenClose-Image')"
            class="mapLegendIcon"
            [ngClass]="rtlEnabled ? 'mapLegendIconRtl' : ''"
          ></mat-icon>
          <div class="mapLegendTitle">
            <Label>{{ res.get('Legend-Title') }} </Label>
            <button mat-icon-button class="reset-button" (click)="resetToDefaults()">
              <mat-icon style="color: white; transform: scaleX(-1)" matTooltip="{{ res.get('Legend-Tooltip') }}"
                >refresh</mat-icon
              >
            </button>
          </div>
        </div>
      </div>
      <div style="flex: 1; overflow: auto" [ngStyle]="{ display: hasData ? 'unset' : 'none' }">
        <mat-tree
          [dataSource]="dataSource"
          [treeControl]="treeControl"
          #matTree
          [ngClass]="rtlEnabled ? 'matTreeRtl' : 'matTree'"
        >
          <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
            <div style="display: flex; width: 100%; align-items: center">
              @if (node.expandable) {
                <button mat-icon-button disabled></button>
              }
              <mat-checkbox
                [class]="node?.node?.style ? 'checklist-leaf-style' : 'checklist-leaf-node'"
                style="font-size: 16px; line-height: 0px; overflow: hidden"
                [checked]="isNodeLayerVisible(node)"
                (change)="toggleLayerItemSelection(node)"
                id="{{ node.item }}"
                [matTooltip]="isMobileEnv ? null : node.displayText"
                (mouseenter)="isEllipsisActive(node)"
                [matTooltipDisabled]="displayTooltip"
                (mouseleave)="toggleDefault()"
              >
                @if (node?.node?.style) {
                  <svg width="16" height="16" viewBox="-0.5 -0.5 1 1" [innerHTML]="sanitize(node.node.style.svgPreviewShapes)"></svg>
                }
                <span class="span-ellipsis" [innerHTML]="node.displayText | highlightSearchTree: searchInput"></span>
              </mat-checkbox>
              <div style="flex: 1"></div>
              @if (canMapZoomToLayer(node) || canMapOpenDataTable(node)) {
                <button mat-icon-button [matMenuTriggerFor]="menu" class="iconMenu">
                  <mat-icon>more_vert</mat-icon>
                </button>
              }
              <mat-menu #menu>
                @if (canMapZoomToLayer(node)) {
                  <button mat-menu-item (click)="mapZoomToLayer(node)">
                    <mat-icon [svgIcon]="res.svgName('Legend-Zoom-Image')" class="leafZoomIcon"></mat-icon>
                    <span>{{ res.get('Legend-Zoom') }}</span>
                  </button>
                }
                @if (canMapOpenDataTable(node)) {
                  <button mat-menu-item (click)="mapOpenDataTable(node)">
                    <mat-icon
                      [svgIcon]="res.svgName('Legend-OpenDataTable-Image')"
                      class="leafOpenDataTableIcon"
                    ></mat-icon>
                    <span>{{ res.get('Legend-OpenDataTable') }}</span>
                  </button>
                }
              </mat-menu>
            </div>
          </mat-tree-node>
          <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
            <mat-checkbox
              [checked]="isNodeLayerVisible(node)"
              style="font-size: 16px"
              [indeterminate]="isNodeLayerVisible(node) && descendantsPartiallySelected(node)"
              (change)="toggleLayerItemSelectionEx(node, $event)"
              id="{{ node.item }}"
              [matTooltip]="isMobileEnv ? null : node.displayText"
              (mouseenter)="isEllipsisActive(node)"
              [matTooltipDisabled]="displayTooltip"
              (mouseleave)="toggleDefault()"
            >
              <button mat-icon-button (click)="toggleNodeExpansion(node)" [attr.aria-label]="'toggle ' + node.filename" [style]="node.expandDisabled ? 'pointer-events:none' : ''">
                <mat-icon
                  class="expendIcon"
                  [ngClass]="!treeControl.isExpanded(node) && rtlEnabled ? 'expendIconRtl' : ''"
                  [style]="node.expandDisabled ? 'color:rgba(0,0,0,0.05) !important' : ''"
                >
                  {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                </mat-icon>
              </button>
              <span class="span-ellipsis" [innerHTML]="node.displayText | highlightSearchTree: searchInput"></span>
            </mat-checkbox>
            <div style="flex: 1"></div>
            @if (canMapZoomToLayer(node) || canMapOpenDataTable(node)) {
              <button mat-icon-button [matMenuTriggerFor]="menu" class="iconMenu">
                <mat-icon>more_vert</mat-icon>
              </button>
            }
            <mat-menu #menu>
              @if (canMapZoomToLayer(node)) {
                <button mat-menu-item (click)="mapZoomToLayer(node)">
                  <mat-icon [svgIcon]="res.svgName('Legend-Zoom-Image')" class="leafZoomIcon"></mat-icon>
                  <span>{{ res.get('Legend-Zoom') }}</span>
                </button>
              }
              @if (canMapOpenDataTable(node)) {
                <button mat-menu-item (click)="mapOpenDataTable(node)">
                  <mat-icon
                    [svgIcon]="res.svgName('Legend-OpenDataTable-Image')"
                    class="leafOpenDataTableIcon"
                  ></mat-icon>
                  <span>{{ res.get('Legend-OpenDataTable') }}</span>
                </button>
              }
            </mat-menu>
          </mat-tree-node>
        </mat-tree>
      </div>
      <div
        class="noDataPlaceHolder"
        [ngStyle]="{ display: !hasData ? 'block' : 'none', 'background-color': '#fff', height: '100%' }"
      >
        &lt;{{ res.get('Legend-FilterNoDataError') }}&gt;
      </div>
    </div>
  </div>
}
